import type { RouteRecordRaw } from 'vue-router'
import { useTerminologyStore } from '@/modules/terminologies/stores/terminology'

export const terminologiesRoutes: RouteRecordRaw[] = [
  {
    path: 'terminologies',
    name: 'study.terminologies',
    component: () => import('@/modules/terminologies/views/TerminologiesView.vue'),
    children: [
      {
        path: 'create',
        name: 'study.terminology.create',
        component: () => import('@/modules/terminologies/views/TerminologyCreate.vue')
      }
    ]
  },
  {
    path: 'terminologies/:terminologyId',
    name: 'terminology.details',
    beforeEnter: async (to) => {
      const { getTerminology } = useTerminologyStore()
      const { terminologyId } = to.params
      if (terminologyId) {
        await getTerminology(terminologyId as string)
      }
    },
    redirect: { name: 'terminology.show' },
    children: [
      {
        path: '',
        name: 'terminology.show',
        component: () => import('@/modules/terminologies/views/TerminologyShowView.vue')
      },
      {
        path: 'update',
        name: 'terminology.update',
        component: () => import('@/modules/terminologies/views/TerminologyUpdateView.vue'),
        redirect: {
          name: 'terminology.update.contents'
        },
        children: [
          {
            path: 'contents',
            name: 'terminology.update.contents',
            component: () => import('@/modules/terminologies/views/TerminologyDesignerView.vue')
          },
          {
            path: 'translation',
            name: 'terminology.update.translations',
            component: () => import('@/modules/terminologies/views/TerminologyTranslationView.vue')
          },
          {
            path: 'settings',
            name: 'terminology.update.settings',
            component: () => import('@/modules/terminologies/views/TerminologySettingsView.vue')
          }
        ]
      }
    ]
  }
]

export default terminologiesRoutes
